'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><g clipPath="url(#blog_svg__a)"><path fill="currentColor" fillRule="evenodd" d="m9.73 12.908.503-1.878a1 1 0 0 1 .26-.448L20.074 1a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414L13.331 13.4a1 1 0 0 1-.468.264l-1.928.474a1 1 0 0 1-1.205-1.23M13 2a1 1 0 1 1 0 2H4a2 2 0 0 0-2 2v16l2-2 .721-.721a3 3 0 0 1 2.122-.879H17.9a2 2 0 0 0 2-2V11a1 1 0 1 1 2 0v5.4a4 4 0 0 1-4 4H7.671a3 3 0 0 0-2.121.879l-2.136 2.135A2 2 0 0 1 0 22V6a4 4 0 0 1 4-4z" clipRule="evenodd" /></g><defs><clipPath id="blog_svg__a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath></defs></svg>;
const IconBlog = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconBlog;